import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';

export const DetailRowLabel: React.FC<PropsWithChildren> = ({ children }) => {
  return <Box css={{ display: 'flex', alignItems: 'center' }}>{children}</Box>;
};
